import gql from 'graphql-tag';
import { apolloClient } from '../apolloClient.js';
import parseUserPreference from '../methods/parseUserPreference.js';

let preferencesPromise;
export const GET_PREFERENCES = gql`
  {
    userPreferences {
      preferenceName
      preferenceValue
      preferenceType
    }
  }
`;

export const SAVE_PREFERENCES = gql`
  mutation saveUserPreferences($query: [PreferenceQuery]) {
    saveUserPreferences(query: $query) {
      preferenceName
      preferenceValue
      preferenceType
    }
  }
`;

export function getPreferences() {
  return preferencesPromise;
}

export function refetchPreferences() {
  return (preferencesPromise = apolloClient
    .query({ query: GET_PREFERENCES })
    .then((res) => {
      const userPreferences = res.data.userPreferences || [];
      return parseUserPreference(userPreferences);
    })
    .catch(() => {
      throw new Error('User Preferences API returned unsuccessful');
    }));
}

export function savePreferences(queryData) {
  return (preferencesPromise = apolloClient
    .mutate({
      mutation: SAVE_PREFERENCES,
      variables: {
        query: queryData,
      },
    })
    .then((res) => {
      const userPreferences = res.data.saveUserPreferences || [];
      return parseUserPreference(userPreferences);
    })
    .catch(() => {
      throw new Error('User Preferences API returned unsuccessful');
    }));
}
